import { useCallback } from "react"
import { useRoleInfo } from "@/user/session"
import { triggerLogin } from "@/utils/loginTrigger"

export const useCheckLogin = () => {
    const user = useRoleInfo()
    return useCallback(() => {
        if (user) return true
        triggerLogin()
        return false
    }, [user])
}
